"use client";
import { useEffect, useState } from "react";

interface Props {
    data: {
        question: string;
        answer: string;
    };
    i: number;
}

const FaqAreaBar = ({ data, i }: Props) => {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const collapseElement = document.getElementById(`collapse${i}`);
        if (!collapseElement) return;

        const handleShow = () => setIsActive(true);
        const handleHide = () => setIsActive(false);

        collapseElement.addEventListener('shown.bs.collapse', handleShow);
        collapseElement.addEventListener('hidden.bs.collapse', handleHide);

        return () => {
            collapseElement.removeEventListener('shown.bs.collapse', handleShow);
            collapseElement.removeEventListener('hidden.bs.collapse', handleHide);
        };
    }, [i]);

    return (
        <div
            className={`accordion-item ${isActive ? 'collapse-active' : ''}`}
        >
            <h3 className="accordion-header">
                <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${i}`}
                    aria-expanded="false"
                    aria-controls={`collapse${i}`}
                >
                    {data.question}
                </button>
            </h3>
            <div
                id={`collapse${i}`}
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
            >
                <div className="accordion-body">{data.answer}</div>
            </div>
        </div>
    );
};

export default FaqAreaBar;
